import { Vector3 } from "core/Maths/math.vector";
import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
/**
 * Block used to apply a cross product between 2 vectors
 */
export class RewardMakeVectorBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("x", RewardGraphConnectionPointTypes.Float);
        this.registerInput("y", RewardGraphConnectionPointTypes.Float);
        this.registerInput("z", RewardGraphConnectionPointTypes.Float);
        this.registerOutput("output", RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardMakeVectorBlock";
    }

    public get x(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    public get y(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    public get z(): RewardGraphConnectionPoint {
        return this._inputs[2];
    }

    /**
     * Gets the output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.x.isConnected || !this.y.isConnected || !this.z.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state) => {
            const x = this.x.getConnectedValue(state);
            const y = this.y.getConnectedValue(state);
            const z = this.z.getConnectedValue(state);

            return new Vector3(x, y, z);
        };

        return this;
    }
}

RegisterClass("MELS.RewardMakeVectorBlock", RewardMakeVectorBlock);
